import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/caret-right.svg")